import React from "react";

const Services = () => {
  return (
    <div
      className="gdlr-core-pbf-wrapper hp1-col-services"
      data-skin="Blue Title"
      id="gdlr-core-wrapper-1"
    >
      <div className="gdlr-core-pbf-background-wrap"></div>
      <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space">
          <div
            className="gdlr-core-pbf-wrapper-container-inner gdlr-core-item-mglr clearfix"
            id="div_1dd7_0"
          >
            {/* Admission */}
            <div className="gdlr-core-pbf-column gdlr-core-column-15 gdlr-core-column-first">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" id="div_1dd7_1">
                <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div className="gdlr-core-pbf-element">
                    <div
                      className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_2"
                    >
                      <div className="gdlr-core-column-service-media gdlr-core-media-image">
                        <img src="upload/icon-1.png" alt="Admission" width="40" height="40" />
                      </div>
                      <div className="gdlr-core-column-service-content-wrapper">
                        <div className="gdlr-core-column-service-title-wrap">
                          <h3 className="gdlr-core-column-service-title gdlr-core-skin-title" id="h3_1dd7_0">
                            Admission
                          </h3>
                          <div
                            className="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_3"
                          >
                            Admissions for the Academic Year 2025
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Labs */}
            <div className="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-1">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" id="div_1dd7_4">
                <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div className="gdlr-core-pbf-element">
                    <div
                      className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_5"
                    >
                      <div className="gdlr-core-column-service-media gdlr-core-media-image">
                        <img src="upload/icon-2.png" alt="Labs" width="44" height="40" />
                      </div>
                      <div className="gdlr-core-column-service-content-wrapper">
                        <div className="gdlr-core-column-service-title-wrap">
                          <h3 className="gdlr-core-column-service-title gdlr-core-skin-title" id="h3_1dd7_1">
                            Labs
                          </h3>
                          <div
                            className="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_6"
                          >
                            Getting Diploma
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Library */}
            <div className="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-2">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" id="div_1dd7_7">
                <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div className="gdlr-core-pbf-element">
                    <div
                      className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_8"
                    >
                      <div className="gdlr-core-column-service-media gdlr-core-media-image">
                        <img src="upload/icon-3.png" alt="Library" width="44" height="39" />
                      </div>
                      <div className="gdlr-core-column-service-content-wrapper">
                        <div className="gdlr-core-column-service-title-wrap">
                          <h3 className="gdlr-core-column-service-title gdlr-core-skin-title" id="h3_1dd7_2">
                            Library
                          </h3>
                          <div
                            className="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_9"
                          >
                            Sport Clubs
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Clinical Facilities */}
            <div className="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-3">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" id="div_1dd7_10">
                <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div className="gdlr-core-pbf-element">
                    <div
                      className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_11"
                    >
                      <div className="gdlr-core-column-service-media gdlr-core-media-image">
                        <img src="upload/icon-4.png" alt="Clinical Facilities" width="41" height="41" />
                      </div>
                      <div className="gdlr-core-column-service-content-wrapper">
                        <div className="gdlr-core-column-service-title-wrap">
                          <h3 className="gdlr-core-column-service-title gdlr-core-skin-title" id="h3_1dd7_3">
                            Clinical Facilities
                          </h3>
                          <div
                            className="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_12"
                          >
                            Overall in here
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
